import {Card} from 'antd';
import cn from 'classnames';
import React, {useState, FC, Key} from 'react';

import {IMenuStructureItem} from 'store/slices/menu-slice/menu-slice-types';

import {CustomTabs} from '../../custom-tabs';
import {
    AisDocumentDocumentCodesTabKey,
    AisDocumentTypeCodesEntityName,
    DocumentCodesFormTitles,
} from '../ais.constants';
import {DocumentCodesTemplateContext} from './document-codes-context';
import {DocumentTypeCodes} from './tabs/document-types-codes/document-type-codes';

import './document-codes.less';

interface IDocumentCodesProps {
    entityName: string;
    url: string;
    allowedSections: IMenuStructureItem[] | undefined;
}

export const DocumentCodes: FC<IDocumentCodesProps> = (
    {
        entityName,
        url,
        allowedSections = [],
    }: IDocumentCodesProps,
) => {
    const [selectedTabKey, setSelectedTabKey] = useState<Key>(
        AisDocumentDocumentCodesTabKey.REFERENCE_BOOK_DOCUMENT_CODES,
    );

    const tabs = [{
        key: AisDocumentDocumentCodesTabKey.REFERENCE_BOOK_DOCUMENT_CODES,
        title: DocumentCodesFormTitles.referenceBookDocumentCodes,
        entityName: AisDocumentTypeCodesEntityName.DOCUMENT_TYPE_CODES_DIRECTORY,
        content: <DocumentTypeCodes
            entityName={AisDocumentTypeCodesEntityName.DOCUMENT_TYPE_CODES_DIRECTORY}
            url={url}
        />,
    }, {
        key: AisDocumentDocumentCodesTabKey.SETTING_DOCUMENT_CODES,
        title: DocumentCodesFormTitles.settingDocumentCodes,
        entityName: AisDocumentTypeCodesEntityName.PRIMARY_DOCUMENTS_CODES_SETTINGS,
        content: <DocumentTypeCodes
            entityName={AisDocumentTypeCodesEntityName.PRIMARY_DOCUMENTS_CODES_SETTINGS}
            url={url}
        />,
        noRenderWhileOnAnotherTab: true,
    }];

    const filteredTabs = tabs.filter(
        item => allowedSections?.find(section => section?.entityName === item.entityName),
    );

    return (
        <div className={cn('document-codes')}>
            <DocumentCodesTemplateContext.Provider
                value={{
                    selectedTabKey,
                    setSelectedTabKey,
                    entityName,
                }}
            >
                <Card
                    title="Настройка кодов первичных документов"
                    className={cn('document-codes__card')}
                >
                    <CustomTabs
                        selectedTabKey={selectedTabKey}
                        setSelectedTabKey={setSelectedTabKey}
                        defaultRenderBehaviourOnSwitchingTabs="unmount"
                        tabs={filteredTabs}
                    />
                </Card>
            </DocumentCodesTemplateContext.Provider>
        </div>
    );
};
